import React from 'react';
import EdexcelALevel from './Row/PredictedPapers/EdexcelALevel';
import EdexcelGCSE from './Row/PredictedPapers/EdexcelGCSE';
import EdexcelIGCSE from './Row/PredictedPapers/EdexcelIGCSE';
import TopicEdexcelGCSE from './Row/Topics/EdexcelGCSE';
import TopicALevel from './Row/Topics/ALevel';
import TopicALevelFurther from './Row/Topics/ALevelFurther';

const RowFactory = ({ row: { original: row } }) => {
  if (!row) return null;

  switch (row.__typename) {
    case 'DatoCmsEdexcelALevelPredictedPaper':
      return <EdexcelALevel row={row} />;
    case 'DatoCmsEdexcelGcsePredictedPaper':
      return <EdexcelGCSE row={row} />;
    case 'DatoCmsEdexcelIgcsePredictedPaper':
      return <EdexcelIGCSE row={row} />;
    case 'DatoCmsEdexcelGcseTopic':
      return <TopicEdexcelGCSE row={row} />;
    case 'DatoCmsEdexcelALevelTopic':
      return <TopicALevel row={row} />;
    case 'DatoCmsEdexcelALevelFurtherTopic':
      return <TopicALevelFurther row={row} />;
    default:
      console.warn(`Unknown row type: ${row.__typename}`);
      return null;
  }
};

export default RowFactory;
